import { Button, Switch, Menu, MenuList, MenuItem, MenuTrigger, MenuPopover } from "@fluentui/react-components";
import { Drawer, DrawerBody, DrawerHeader, DrawerHeaderTitle, useRestoreFocusSource,  useRestoreFocusTarget, } from "@fluentui/react-components";

import { Persona } from "@fluentui/react-components";
import * as React from 'react';
import { logout, User } from '../../api/AuthProvider';
import { getPhoto } from '../../api/GraphProvider';
import { useGlobalState } from '../../service/globalState.service';
import { setDarkTheme, setShowAllTasks, setPendingCategory } from '../../service/settingsState.service';

const { useEffect, useState } = React;

interface HeaderProps {
  user: User;
}

export const Header: React.FC<HeaderProps> = ({ user }) => {
  const [avatar, setAvatar] = useState<string>();
  const [isOpen, setIsOpen] = React.useState(false);
  const [{ darkTheme, pendingCategory, showAllTasks }] = useGlobalState('settings');

  useEffect(() => {
    requestPhoto();
  }, []);

  const requestPhoto = async () => {
    const res = await getPhoto();
    const imageBlob = await res.blob();
    const imageObjectURL = URL.createObjectURL(imageBlob);
    setAvatar(imageObjectURL);
  }

  //const toggleOpen = () => setOpen(!isOpen);
  const restoreFocusTargetAttributes = useRestoreFocusTarget();
  const restoreFocusSourceAttributes = useRestoreFocusSource();

  const openFeedbackSite = () => window.open('https://forms.office.com/r/PUafMFKZWk', '_blank');

  const workaround = () => {
    const container = document.querySelector('.ms-Panel-scrollableContent');
    if (container && container['style']) {
      container['style'].background = 'inherit';
    }
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}>
      <Persona
        secondaryText={user.email}
        name={user.name}
        presence={{ status: "available" }}
        avatar={{
        image: {
          src: avatar,
        },
      }}
      />

      <Drawer
        {...restoreFocusSourceAttributes}
        separator
        open={isOpen}
        onOpenChange={(_, { open }) => setIsOpen(open)}
      >

        <DrawerHeader>
          <DrawerHeaderTitle>Settings</DrawerHeaderTitle>
        </DrawerHeader>
        <DrawerBody>
          <Persona
          secondaryText={user.email}
          name={user.name}
          presence={{ status: "available" }}
          avatar={{
            image: {
              src: avatar,
            },
          }}
        />

        <br />

        
        <Switch
          checked={darkTheme}
          label={darkTheme ? "Dark mode" : "Light mode"}   // explicit label prop/slot
          labelPosition="after"
          onChange={(_, data) => {
            workaround();
            setDarkTheme(!!data.checked);
          }}
        />

        <Switch
          label="Pending Allocatus category"
          checked={pendingCategory}
          onChange={(e, c) => {
            workaround();
            setPendingCategory(c.checked);
          }}
        />
        <Switch
          label="Show all tasks in list"
          checked={showAllTasks}
          onChange={(e, c) => {
            workaround();
            setShowAllTasks(c.checked);
            setTimeout(() => location.reload(), 300);
          }}
        />
        </DrawerBody>
      </Drawer>

      

      <Menu>
      <MenuTrigger>
        <Button icon={<span className="ms-Icon ms-Icon--CollapseMenu" />} />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            icon={<span className="ms-Icon ms-Icon--Settings" />}
            onClick={() => 
              setIsOpen(true)}
          >
          Settings
          </MenuItem>
          <MenuItem
          icon={<span className="ms-Icon ms-Icon--Feedback" />}
          onClick={openFeedbackSite}
          >
          Give feedback
          </MenuItem>
          <MenuItem
          icon={<span className="ms-Icon ms-Icon--SignOut" />}
          onClick={logout}
          >
          Log out
          </MenuItem>
        </MenuList>
      </MenuPopover>
      </Menu>
    </div>
  )
}